import React from 'react';
import axios from 'axios';
import { useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ProchainMatchAffichage from './prochainMatchAffichage';
import AncienMatchAffichage from './ancienMatchAffichage';

function MatchDetailsArbitrage(props) {
    const [equipe, setEquipe] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const {idEquipe, nomEquipe} = useParams();
    const [pasDispo, setPasDispo] = useState(false);
    const Navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;



  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/arbitrage/affichage/${idEquipe}`,
          {
            withCredentials: true 
          }
        );
        setEquipe(response.data);
        setError(null);
        setIsLoading(false);

      } catch (error) {
        if (error.response) {
            if (error.response.status === 404) {
                setPasDispo(true);
            } else {
                setError(error.response.data.message);
            }
        } else {
            setError(true);
        }
        setIsLoading(false);

      }
    };

    fetchData(); 
  }, [apiUrl, idEquipe]);
  

        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }
        if(error){
            return (
                <>
                <div id="alert-message" className="alert4" >
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
              </>  
            )
        }

  return (
    <>
    {pasDispo && (
        <Modal show={pasDispo} onHide={() => Navigate('/arbitre/tableau-de-bord/arbitrage')}>
                <Modal.Header closeButton>
                  <Modal.Title>Aucun match trouvé pour cette équipe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <>Aucun match trouvé pour <strong>{nomEquipe}</strong>.</>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => Navigate('/arbitre/tableau-de-bord/arbitrage')} >
                    Quitter
                  </Button>
                </Modal.Footer>
        </Modal>
    )}
    {equipe && (
        <>
            <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
              <Card.Img src="/img/candidature.jpg" alt="Card image" />
            </Card><br/>
            <div className="text-center mb-3">
                  <Card.Title><strong>Voir les avis des anciens matchs</strong></Card.Title><br/>
            </div>
            <AncienMatchAffichage userData={props.userData} equipe={equipe}/>
            <div className="text-center mb-3">
                  <Card.Title><strong>Envoyer une candidature pour les prochains matchs</strong></Card.Title><br/>
            </div>
            <ProchainMatchAffichage userData={props.userData} equipe={equipe}/>
            <br/>
        </>
    )}

    </>
  );
}

export default MatchDetailsArbitrage;